import type { AnyAction } from 'redux';
import { REGISTER_FORM } from '../action-types.js';

export const onFormRegister =
  (formName: string) =>
  (action: AnyAction): boolean =>
    action.type === REGISTER_FORM && action.meta.formName === formName;
